/* ------------------------------------------------------------------ */
/*  Types                                                              */
/* ------------------------------------------------------------------ */

import { FRAUD_CONFIG } from '../../constants/interaction/constants';

export interface ScrollSample {
  y: number;
  time: number;
  direction: 'up' | 'down';
}

/* ------------------------------------------------------------------ */
/*  Pure helpers                                                       */
/* ------------------------------------------------------------------ */

export function getMinDirectionChangeDistance(viewportWidth: number): number {
  return viewportWidth < FRAUD_CONFIG.mobileBreakpoint
    ? FRAUD_CONFIG.minDirectionChangeDistanceMobile
    : FRAUD_CONFIG.minDirectionChangeDistanceDesktop;
}

export function computeScrollSpeed(prev: ScrollSample, currentY: number, now: number): number | null {
  const timeDeltaMs = now - prev.time;
  if (timeDeltaMs <= 0) {
    return null;
  }
  return Math.abs(currentY - prev.y) / timeDeltaMs;
}

export function countShortDirectionChanges(samples: readonly ScrollSample[], minDistance: number): number {
  let changes = 0;
  let lastChangeY = samples[0]?.y ?? 0;

  for (let i = 1; i < samples.length; i++) {
    const isDirectionChanged = samples[i].direction !== samples[i - 1].direction;
    if (!isDirectionChanged) {
      continue;
    }

    const distance = Math.abs(samples[i].y - lastChangeY);
    if (distance < minDistance) {
      changes++;
    }
    lastChangeY = samples[i].y;
  }

  return changes;
}

export function trimSamplesToWindow(
  samples: readonly ScrollSample[],
  newSample: ScrollSample,
): readonly ScrollSample[] {
  const windowStart = newSample.time - FRAUD_CONFIG.directionChangeWindowMs;
  const trimmed: ScrollSample[] = [];
  for (let i = 0; i < samples.length; i++) {
    if (samples[i].time >= windowStart) {
      trimmed.push(samples[i]);
    }
  }
  trimmed.push(newSample);
  return trimmed;
}
